export default "__VITE_ASSET__bb5193e0__$_?inline__"